import { AnalyticsHandler } from '@Foundation';

const getUserActionEventTagging = (label, ctaName, productInfo) => {
  return {
    type: 'userActionEvent',
    event_name: 'findation_interaction',
    category: '__pageCategory__::findation',
    action: 'widget',
    label,
    click_action: label,
    cta_name: ctaName,
    product_info: productInfo,
    service_name: 'findation',
  };
};

export function pushWidgetEmbeddedTagging() {
  AnalyticsHandler.getAnalyticsHandler().push({
    type: 'nonInteractiveEvent',
    event_name: 'findation_widget_impression',
    category: 'findation',
    action: 'widget',
    label: 'impression',
  });
}

export function getAnalytics(label, ctaName, productInfo) {
  AnalyticsHandler.getAnalyticsHandler().push(
    getUserActionEventTagging(label, ctaName, productInfo)
  );
}

export function proceedTriggerRedirect(payload, productApiUrl, productInfo) {
  const ean = payload.ean;
  const url = `${productApiUrl}?ean=${ean}`;

  fetch(url)
    .then((response) => response.json())
    .then((jsonData) => {
      if (jsonData.Url) window.location.assign(jsonData.Url);

      if (ean) {
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          event_name: 'buy_now',
          category: 'Ecommerce',
          action: 'click to buy',
          label: `${jsonData.Name}::${ean}::${jsonData.ShadeName}`,
          product_info: productInfo,
          event_detail: 'findation',
        });
      }
    });
}

export function pushNoMatchTagging(ctaName, productInfo) {
  const tagging = getUserActionEventTagging('no recommendation', ctaName, productInfo);
  tagging.event_detail = 'none';

  AnalyticsHandler.getAnalyticsHandler().push(tagging);
}

export function pushAddMoreProductsTagging(ctaName, productInfo, recommendedProductShade) {
  const tagging = getUserActionEventTagging(ctaName, ctaName, productInfo);
  tagging.event_detail = recommendedProductShade;
  delete tagging.service_name;

  AnalyticsHandler.getAnalyticsHandler().push(tagging);
}

export function pushVToTagging(ctaName, productInfo, recommendedProductShade) {
  const tagging = getUserActionEventTagging(ctaName, ctaName, productInfo);
  tagging.event_detail = recommendedProductShade;
  delete tagging.service_name;

  AnalyticsHandler.getAnalyticsHandler().push(tagging);
}

export function pushCloseTagging(productInfo) {
  const ctaName = 'closed';
  const tagging = getUserActionEventTagging(ctaName, ctaName, productInfo);
  delete tagging.cta_name;

  AnalyticsHandler.getAnalyticsHandler().push(tagging);
}

export function pushShadeRecommendationTagging(ctaName, productInfo, recommendedProductShade) {
  const tagging = getUserActionEventTagging('recommendation', ctaName, productInfo);
  tagging.event_detail = recommendedProductShade;

  AnalyticsHandler.getAnalyticsHandler().push(tagging);
}
